import React, { useState } from "react";
import styles from "../styles/Content.module.css";
import { Button, Form, Select } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";

const COLORS = ["#FF671D", "#585858", "#e8e8e8"];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  value,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text
      x={x}
      y={y}
      fill={index === 2 ? "#585858" : "#FFF"}
      textAnchor={x > cx ? "start" : "end"}
      fontWeight="bold"
      fontSize="25px"
      fontFamily="Roboto, Arial"
      dominantBaseline="central"
    >
      {value}
    </text>
  );
};

const AverageTimes = ({ branches, timeAverages, isAdmin }) => {
  const [locationSelected, handleLocationSelected] = useState(null);
  const filterByBranch = ({ location }) => {
    handleLocationSelected(location);
  };
  const mapData = (type) => {
    if (!locationSelected && type === "branch") {
      return timeAverages[0]?.branch;
    }
    if (!locationSelected && type === "driver") {
      return timeAverages[0]?.driver;
    }
    const timeAveragesByBranch = timeAverages.filter(
      (item) => item.branch_id === locationSelected
    );

    if (type === "branch") {
      return timeAveragesByBranch[0]?.branch;
    }

    if (type === "driver") {
      return timeAveragesByBranch[0]?.driver;
    }
  };
  return (
    <div className={styles.cardContent}>
      {isAdmin && (
        <div className={styles.filterForm}>
          <Form layout="inline" onFinish={filterByBranch}>
            <Form.Item name="location">
              <Select
                className={styles.select}
                showSearch
                optionFilterProp="label"
                options={branches.map((item) => {
                  return { value: item.id, label: item.zone };
                })}
                placeholder="Todas las sucursales"
                allowClear
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" icon={<FilterOutlined />} style={{ display: 'inline-flex', alignItems: 'center' }}>
              Filtrar
            </Button>
          </Form>
        </div>
      )}

      <div className={styles.chartLegends}>
        <span className={styles.chartLegend}>
          <span className={`${styles.chartLegendDot} ${styles.chartLegendDotAcceptance}`} />
          <span>Aceptación</span>
        </span>
        <span className={styles.chartLegend}>
          <span className={`${styles.chartLegendDot} ${styles.chartLegendDotPreparation}`} />
          <span>En preparación</span>
        </span>
        <span className={styles.chartLegend}>
          <span className={`${styles.chartLegendDot} ${styles.chartLegendDotOnTheWay}`} />
          <span>En camino</span>
        </span>
      </div>

      <div className={styles.charts}>
        <div className={styles.chartCard}>
          <p className={styles.chartCardTitle}>Sucursales</p>
          <div className={styles.chartContent}>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={mapData("branch")}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={renderCustomizedLabel}
                  outerRadius={125}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {mapData("branch")?.map((_, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className={styles.chartCard}>
          <p className={styles.chartCardTitle}>Drivers</p>
          <div className={styles.chartContent}>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={mapData("driver")}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={renderCustomizedLabel}
                  outerRadius={125}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {mapData("driver")?.map((_, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
      <p className={styles.legend}>*Tiempos promedios en minutos</p>
    </div>
  );
};

export default AverageTimes;
